import type { Region, User } from '../context/AuthContext';
import api from './client';

interface LoginResponse {
  token: string;
  user: User;
}

interface MeResponse {
  user: User;
}

export const loginAPI = (email: string, password: string): Promise<LoginResponse> =>
  api.post('/auth/login', { email, password }).then((res) => res.data);

export const verifyTokenAPI = (): Promise<MeResponse> =>
  api.get('/auth/me').then((res) => res.data);

export const forgotPasswordAPI = (email: string): Promise<{ ok: boolean }> =>
  api.post('/auth/forgot', { email }).then((res) => res.data);

export const resetPasswordAPI = (token: string, newPassword: string): Promise<{ ok: boolean }> =>
  api.post('/auth/reset', { token, newPassword }).then((res) => res.data);

// Admin-only user CRUD — matches the new backend's Zod schema (includes `region`).
// The rest of the users module is stubbed on the backend; these will 404 until ported.
export const registerAPI = (input: {
  email: string;
  name: string;
  password: string;
  region: Region | 'BOTH';
  assignedStores?: number[];
  type?: 'user' | 'admin' | 'superadmin';
  permissions?: string[];
}) => api.post('/auth/register', input).then((res) => res.data);

export const listUsersAPI = () => api.get('/users').then((res) => res.data);

// Same list but INCLUDES the current user — for filter dropdowns
// (e.g. Shipments "Created By") where the caller needs to see
// themselves as a filter option.
export const listUsersDirectoryAPI = () =>
  api.get('/users', { params: { includeSelf: 1 } }).then((res) => res.data);

export const createUserAPI = (input: {
  email: string;
  name: string;
  password: string;
  region: Region | 'BOTH';
  assignedStores?: number[];
  type?: 'user' | 'admin' | 'superadmin';
  permissions?: string[];
}) => api.post('/users', input).then((res) => res.data);

export const updateUserAPI = (
  userId: number,
  input: {
    email: string;
    name: string;
    region?: Region | 'BOTH';
    assignedStores?: number[];
    type?: 'user' | 'admin' | 'superadmin';
    permissions?: string[];
  },
) => api.put(`/users/${userId}`, input).then((res) => res.data);

export const deleteUserAPI = (userId: number) =>
  api.delete(`/users/${userId}`).then((res) => res.data);

export const changePasswordAPI = (userId: number, newPassword: string) =>
  api.put(`/users/${userId}/password`, { newPassword }).then((res) => res.data);
